<section class="info-card-panel" *ngIf="data" #panelElRef>
  <div class="info-card-panel__wrapper">
    <div
      class="info-card-panel__content"
      [ngClass]="{ rounded: data?.roundedCorners?.value }"
    >
      <h2 *ngIf="data.title?.value" class="info-card-panel__title" #titleEl>
        {{ data.title.value }}
      </h2>

      <div class="info-card-panel__body" *ngIf="isReversed === false">
        <div
          *ngIf="data.description?.value"
          class="info-card-panel__description rte"
          [innerHTML]="data.description.value | safe"
          #descriptionEl
        ></div>

        <div *ngIf="hasImage; then imageBlock; else videoBlock"></div>
      </div>

      <div class="info-card-panel__body" *ngIf="isReversed">
        <div *ngIf="hasImage; then imageBlock; else videoBlock"></div>
        <div
          *ngIf="data.description?.value"
          class="info-card-panel__description rte"
          [innerHTML]="data.description.value | safe"
        ></div>
      </div>
    </div>
  </div>
</section>

<ng-template #videoBlock>
  <div
    *ngIf="media"
    class="info-card-panel__media-holder info-card-panel__media-holder--with-video"
  >
    <div
      *ngIf="
        media.desktop.type === 2;
        then videoDeskLocalBlock;
        else videoDeskNoLocalBlock
      "
    ></div>
    <div
      *ngIf="
        media.mobile.type === 2;
        then videoMobLocalBlock;
        else videoMobNoLocalBlock
      "
    ></div>
  </div>
</ng-template>

<ng-template #imageBlock>
  <div *ngIf="data?.media?.value?.image?.src" class="info-card-panel__image">
    <img
      [src]="data?.media?.value?.image?.src"
      [alt]="data?.media?.value?.image?.alt"
      [ngStyle]="{aspectRatio: data?.media?.value?.image?.width / data?.media?.value?.image?.height}"
    />
  </div>
</ng-template>

<ng-template #videoDeskNoLocalBlock>
  <app-info-panel-video-lightbox
    [data]="media.desktop"
    class="info-card-panel__video info-card-panel__video--desktop"
  ></app-info-panel-video-lightbox>
</ng-template>

<ng-template #videoMobNoLocalBlock>
  <app-info-panel-video-lightbox
    [data]="media.mobile"
    class="info-card-panel__video info-card-panel__video--mobile"
  ></app-info-panel-video-lightbox>
</ng-template>

<ng-template #videoDeskLocalBlock>
  <video
    controls="false"
    preload="true"
    autoplay="autoplay"
    loop="loop"
    [muted]="'muted'"
    name="media"
    class="info-card-panel__video info-card-panel__video--desktop"
  >
    <source [src]="media.desktop.url" type="video/mp4" />
  </video>
</ng-template>
<ng-template #videoMobLocalBlock>
  <video
    controls="false"
    preload="true"
    autoplay="autoplay"
    loop="loop"
    [muted]="'muted'"
    name="media"
    class="info-card-panel__video info-card-panel__video--mobile"
  >
    <source [src]="media.mobile.url" type="video/mp4" />
  </video>
</ng-template>
